<template>
  <div class="modal-content">
    <form
      class="attachment-edit-form"
      autocomplete="off"
    >
      <div>
        <naj-input
          :type-id="formFieldType.text"
          :value.sync="formModel.name"
          :label="local.attachments.attachmentName"
          validates="required"
        ></naj-input>
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.category"
          :items="attachmentCategories"
          :label="local.attachments.attachmentType"
          validates="required"
          item-text="name"
          item-value="id"
          :disabled="attachmentTypeDisabled"
        ></naj-input>
      </div>

      <load-local-attachment
        :accept="accept"
        :max-file-size="maxFileSize"
        @fileSelected="$emit('fileSelected', $event)"
      >
      </load-local-attachment>
      <!-- <div class="or-text">{{ local.common.or }}</div> -->
      <!-- <load-local-attachment
        @fileSelected="$emit('fileSelected', $event)"
        :isScanner="true"
      ></load-local-attachment> -->
    </form>

    <div
      v-if="loading"
      class="loader-holder"
    >
      <naj-loader></naj-loader>
    </div>
    <template v-else>
      <div
        v-if="formModel.fileUrl"
        :class="['attachment-file-viewer', isImage ? 'image-file' : 'pdf-file']"
      >
        <button
          text
          class="full-screen-button"
          @click="$emit('showFullScreen')"
        >
          <v-icon class="icon">
            mdi-arrow-expand
          </v-icon>
        </button>
        <image-editor
          v-if="isImage"
          :image-url="formModel.fileUrl"
          :image-name="formModel.name"
          :preview-mode="previewMode"
          @updateImage="updateImageUrl"
        ></image-editor>

        <div
          v-else
          class="pdf-container"
        >
          <div class="pdf-wrapper">
            <div class="pdf-holder">
              <embed
                class="pdf-viewer"
                :src="fileUrl"
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ImageEditor from './image-editor';
import LoadLocalAttachment from './load-local-attachment';
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

export default {
  components: {
    ImageEditor,
    LoadLocalAttachment,
  },
  props: {
    formModel: { type: Object },
    attachmentCategories: { type: Array },
    loading: { type: Boolean },
    isImage: { type: Boolean },
    previewMode: {},
    accept: { type: String },
    maxFileSize: { type: Number },
    attachmentTypeDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    fileUrl () {
      return getBlobUrl(this.formModel.fileUrl, this.isImage);
    },
  },
  methods: {
    updateImageUrl(imageUrl) {
      this.formModel.fileUrl = imageUrl;
    },
    validateForm() {
      return this.$validator.validateAll();
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  width: 100%;
  height: 608px;
}
.preview-holder {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.rotate-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  position: relative;
  z-index: 56;
  &.pdf-rotate {
    margin-top: 65px;
  }

  .action {
    width: calc(50% - 2px);
    height: 54px;
    margin-top: 2px;
    background-color: #f1f2f6;
    color: #000000;
    text-align: center;
    &:hover {
      background-color: #eee;
    }
    &.v-icon.v-icon::after {
      content: none;
    }
  }
}
.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        height: 100%;
        width: 100%;
        display: inline-block;
      }
    }
  }
}
</style>